/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TravelLog } from '../models/TravelLog'
import type { TravelLogResponse } from '../models/TravelLogResponse'
import type { TravelLogResponseArray } from '../models/TravelLogResponseArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class TravelLogService {
  /**
   * 📱 Store a TravelLog
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeTravelLog(requestBody?: TravelLog): CancelablePromise<{
    data?: TravelLogResponse
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/travelLog/store',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Update a TravelLog
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static updateTravelLog(
    requestBody?: TravelLog,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/travelLog/update',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Retrieves TravelLogs based on the given Event Ids
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static getTravelLogs(requestBody?: {
    event_ids: Array<number>
    employee_id: number
  }): CancelablePromise<{
    data?: TravelLogResponseArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/travelLog/showMany',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
}
